// extracted by mini-css-extract-plugin
module.exports = {"productMerchCard":"ProductMerchCard_productMerchCard__QI6by"};